/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductCategoryRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ProductCategoryRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ProductCategoryRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ProductCategoryRegexQueryOperator>): ProductCategoryRegexQueryOperator {
        let obj = Object.assign(new ProductCategoryRegexQueryOperator(), model);
        ProductCategoryRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductCategoryRegexQueryOperator>): ProductCategoryRegexQueryOperator {
        if (!model) return null;
        return ProductCategoryRegexQueryOperator.newInstance(<ProductCategoryRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductCategoryRegexQueryOperator) {
        if (!obj) return;

        models.ProductCategoryRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductCategoryRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProductCategoryRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.product_category) {
            models.Regex.fixupPrototype(this.product_category);
        }
    }

    /**
     * Include response that has the given product_category filter that has the given value
     */
    product_category: models.Regex;

}
